import { Event } from 'model';
import { FormValidationRules } from '../hooks/useFormValues';

export const EventEditRules: FormValidationRules<Event> = {
	topic: {
		rules: {
			required: {
				value: true,
				message: 'Event Topic is required'
			},
			maxLength: {
				value: 20,
				message: 'Must be less than {value} characters'
			},
			pattern: {
				value: /^\S*$/,
				message: 'Must be one word'
			}
		}
	},
	title: {
		rules: {
			maxLength: {
				value: 80,
				message: 'Must be less than {value} characters'
			},
			minLength: {
				value: 10,
				message: 'Must be more than {value} characters'
			},
			required: {
				value: true,
				message: 'Event title is required'
			}
		}
	},
	contents: {
		rules: {
			maxLength: {
				value: 1000,
				message: 'Must be less than {value} characters'
			},
			required: {
				value: true,
				message: 'Event description is required'
			}
		}
	},
	location: {
		rules: {
			required: {
				value: true,
				message: 'Location is required'
			},
			maxLength: {
				value: 200,
				message: 'Must be less than {value} characters'
			}
		}
	}
};
